import { JobOpeningIcon } from "../assets/svg/JobOpening";
import { LocationIcon } from "../assets/svg/LocationIcon";
import { DescriptionIcon } from "../assets/svg/DescriptionIcon";
import { AttachmentIcon } from "../assets/svg/AttachmentIcon";

export const tabsData = [
    { label: 'Job opening', Icon: JobOpeningIcon },
    { label: 'Address information', Icon: LocationIcon },
    { label: 'Description information', Icon: DescriptionIcon },
    { label: 'Attachment information', Icon: AttachmentIcon },
];

export const interviewTabsData = [
    { label: 'Interview Details', Icon: JobOpeningIcon },
    { label: 'Additional information', Icon: DescriptionIcon },
]

export const applicationTabsData = [
    { label: 'Candidate detail', Icon: JobOpeningIcon },
    { label: 'Cover letter', Icon: DescriptionIcon },
]

export const departmentTabsData = [
    { label: 'Department detail', Icon: JobOpeningIcon },
]